'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ONLY_WHITESPACE_REGEXP = /^[\r\n ]+$/;

exports.default = angular.module('ifeis.enterable.elements', []).directive('enterableContainer', function () {
  return {
    restrict: 'A',
    controller: function CommentsController($scope, $element) {
      this.onClick = function (event, scope, currentEl) {
        var textareas = $element[0].querySelectorAll('[enterable-textarea]');
        textareas.length > 0 && textareas[0].focus();
      };

      this.onKeyPress = function (event, scope, currentEl) {
        if ((event.keyCode === 13 || event.keyCode === 9) && !event.shiftKey) {
          var textareas = $element[0].querySelectorAll('[enterable-textarea]');
          event.preventDefault();
          if (ONLY_WHITESPACE_REGEXP.test(currentEl[0].value)) {
            currentEl[0].value = '';
          }

          var findIndex = Array.prototype.findIndex;
          var idx = findIndex.call(textareas, function (textarea) {
            return textarea === currentEl[0];
          });

          if (idx + 1 <= textareas.length - 1) {
            textareas[idx + 1].focus();
          } else {
            textareas[0].focus();
          }
        }
      };
    }
  };
}).directive('enterableTextarea', function () {
  return {
    require: '^^enterableContainer',
    restrict: 'A',
    link: function link(scope, element, attrs, commentsCtrl) {
      element.on('keydown', function (event) {
        commentsCtrl.onKeyPress(event, scope, element);
      });
    }
  };
}).directive('enterableAutofocusOnClick', function () {
  return {
    require: '^?enterableContainer',
    restrict: 'A',
    link: function link(scope, element, attrs, commentsCtrl) {
      element.on('click', function (event) {
        commentsCtrl.onClick(event, scope, element);
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./enterable-elements/index.js
// module id = 208
// module chunks = 0